import React, { createContext } from "react";
import NastavitveProvider from "./NastavitveProvider";
import Nullable from "../../types/Nullable";
import useFetchNastavitevAll from "./NastavitevHooks";
import ApiStatus from "../../components/ApiStatus";

export const NastavitveContext = createContext<Nullable<NastavitveProvider>>(null);

type NastavitveContextProviderArgs = {
    children?: React.ReactNode;
}

const NastavitveContextProvider = ({ children }: NastavitveContextProviderArgs) => {
    const { data: nastavitveList, status, isSuccess } = useFetchNastavitevAll();

    if (!isSuccess)
        return <ApiStatus status={status}></ApiStatus>

    // if (!isSuccess)
    //     throw new Error(`Napaka pri branju nastavitev (NastavitveContextProvider.useFetchNastavitevAll)`);

    const nastavitve: NastavitveProvider = new NastavitveProvider(nastavitveList);

    return (
        <NastavitveContext.Provider value={nastavitve}>
            {children}
        </NastavitveContext.Provider>
    );
}

export { NastavitveContextProvider };